var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import createElement from '../logical-components/createElement';
import rememberMeVisualComponent from '../visual-components/rememberMe';
import handleErrorUtil from '../core/utils/handleError';
import getIdFromLocation from "../core/utils/getIdFromLocation";
// API
import api from '../core/utils/api';
// Global helpers
import svgs from '../visual-components/svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
import widgetStyleDetection from '../logical-components/widgetStyleDetection';
// section Helpers
import generateMeta from '../visual-components/card-meta';
import generateCondolences from '../logical-components/rememberMe-condolences';
import generateServices from '../visual-components/rememberMe-services';
import generateActions from '../visual-components/rememberMe-actions';
import generateGallery from '../visual-components/rememberMe-gallery';
import generateAdvertisements from '../visual-components/rememberMe-advertisements';
// import { condolences as condolencesMock, rememberMe as rememberMeMock } from '../../_mocks_/rememberMeMock'
// import serviesMock from '../../_mocks_/services'
// Simple section for the powered by footer
var rememberMe = function (_a) {
    var _b;
    var config = _a.config, section = _a.section, data = _a.data;
    var dataToUse = data;
    var hasData = !!dataToUse;
    var services = [];
    var condolencesState = { data: [], meta: {} };
    // get latest id from url
    var personId = getIdFromLocation(window.location) || ((_b = section === null || section === void 0 ? void 0 : section.options) === null || _b === void 0 ? void 0 : _b.defaultId);
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-rememberMewrapper' },
    ]);
    if (!personId && !hasData) {
        handleErrorUtil({
            section: 'rememberMe',
            message: "person ID not defined",
        });
        return wrapper;
    }
    var handleError = function (invalid) {
        if (invalid) {
            wrapper.classList.add('_msnlq-error-true');
            wrapper.classList.remove('_msnlq-posted-true');
        }
        else {
            var tabs = wrapper.querySelector('._msnlq-tabs');
            var content = wrapper.querySelector('._msnlq-tabs-contentblocks');
            // Hide the contentform
            tabs.setAttribute('style', 'display: none;');
            content.setAttribute('style', 'display: none;');
            wrapper.classList.remove('_msnlq-error-true');
            wrapper.classList.add('_msnlq-posted-true');
        }
    };
    var onSubmit = function (type, state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // post
        var post = function (payload) {
            var updatedPayload = {
                type: type === 'write' ? 'condolence' : type,
                first_name: payload.firstName,
                last_name: payload.lastName,
                email: payload.email,
            };
            if (payload.message) {
                updatedPayload.comment = payload.message;
            }
            if (payload.videoUrl) {
                updatedPayload.youtube_url = payload.videoUrl;
            }
            api.post("/person/".concat(personId, "/interaction"), updatedPayload, {
                'X-Widget-Id': config._id,
                'X-Widget-Instance-Id': config._widgetInstanceId,
                'X-Customer-Id': config._customerId,
            })
                .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // console.log(response)
                            if (!response.ok) {
                                handleError(true);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, response.json()];
                        case 1:
                            message = _a.sent();
                            // console.log(message)
                            if (message.errors) {
                                handleError(true);
                                return [2 /*return*/];
                            }
                            handleError(false);
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (responseJson) {
                // console.log(responseJson)
                handleError(true);
            });
        };
        // validation
        if (type === 'write') {
            if (((_b = (_a = state === null || state === void 0 ? void 0 : state.write) === null || _a === void 0 ? void 0 : _a.firstName) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                ((_d = (_c = state === null || state === void 0 ? void 0 : state.write) === null || _c === void 0 ? void 0 : _c.lastName) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                ((_f = (_e = state === null || state === void 0 ? void 0 : state.write) === null || _e === void 0 ? void 0 : _e.email) === null || _f === void 0 ? void 0 : _f.length) > 0 &&
                ((_h = (_g = state === null || state === void 0 ? void 0 : state.write) === null || _g === void 0 ? void 0 : _g.message) === null || _h === void 0 ? void 0 : _h.length) > 0) {
                post(state.write);
            }
            else {
                handleError(true);
            }
        }
        else {
            if (((_k = (_j = state[type]) === null || _j === void 0 ? void 0 : _j.firstName) === null || _k === void 0 ? void 0 : _k.length) > 0 &&
                ((_m = (_l = state[type]) === null || _l === void 0 ? void 0 : _l.lastName) === null || _m === void 0 ? void 0 : _m.length) > 0 &&
                ((_p = (_o = state[type]) === null || _o === void 0 ? void 0 : _o.email) === null || _p === void 0 ? void 0 : _p.length) > 0) {
                post(state[type]);
            }
            else {
                handleError(true);
            }
        }
    };
    var render = function (updatedData, updatedServices, updatedCondolences) {
        var _a, _b;
        // Refresh DOM state
        wrapper.innerHTML = '';
        // Loading state
        if (!updatedData) {
            wrapper.innerHTML = "<div class=\"_mnslq-loader-wrapper\">\n                <span class=\"_mnslq-loader\"></span>\n            </div>";
            return;
        }
        // Setup events for views callback
        var events = internalEvents(config);
        if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.section) {
            var ele = (_b = section === null || section === void 0 ? void 0 : section.views) === null || _b === void 0 ? void 0 : _b.section({
                config: config,
                section: section,
                data: updatedData,
                services: updatedServices,
                svgs: svgs,
                renderText: renderText,
                events: events,
                generatedMeta: generateMeta(config, section, {
                    meta: {
                        writes: (data === null || data === void 0 ? void 0 : data.condolence_count) || 0,
                        candles: (data === null || data === void 0 ? void 0 : data.candle_count) || 0,
                        flowers: (data === null || data === void 0 ? void 0 : data.flower_count) || 0,
                    },
                }),
                generatedCondolences: generateCondolences(config, section, updatedCondolences, updatedData.id),
                generatedServices: generateServices(config, section, services),
                generatedActions: generateActions(config, section, onSubmit),
                generatedGallery: generateGallery(config, section, dataToUse.gallery),
                generatedAdvertisements: generateAdvertisements(config, section, dataToUse.advertisements),
            });
            if (typeof ele === 'string') {
                wrapper.innerHTML = ele;
            }
            else {
                wrapper.appendChild(ele);
            }
        }
        else {
            wrapper.appendChild(rememberMeVisualComponent({
                config: config,
                section: section,
                data: updatedData,
                services: updatedServices,
                condolences: updatedCondolences,
                onSubmit: onSubmit,
            }));
        }
        // When we rerender, we need to recalc the style to use
        widgetStyleDetection(wrapper.querySelector('._mnslq-rememberMe-element'), config);
    };
    // initial render
    render(dataToUse, services, condolencesState);
    // Async data requests
    var getCondolences = function () {
        api("/person/".concat(personId || data.id, "/interaction?page=1"), [], {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            condolencesState = data;
            render(dataToUse, services, condolencesState);
        });
    };
    if (!hasData) {
        api("/person/".concat(personId || data.id), [], {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            dataToUse = data;
            hasData = true;
            render(dataToUse, services, condolencesState);
            if (condolencesState.data.length === 0) {
                getCondolences();
            }
        });
    }
    else {
        if (condolencesState.data.length === 0) {
            getCondolences();
        }
    }
    return wrapper;
};
export default rememberMe;
